var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrientationPortrait(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.255 21c.963 0 1.745-.756 1.745-1.688V4.687C19 3.756 18.218 3 17.255 3H6.745C5.782 3 5 3.756 5 4.687v14.625C5 20.244 5.782 21 6.745 21h10.51zm-.219-1.688H6.964a.215.215 0 01-.219-.21V4.898c0-.116.099-.21.219-.21h10.072c.12 0 .219.094.219.21v14.204c0 .116-.099.21-.219.21z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/540bf9ce8eed3e45e8ed6ad2719100e2-OrientationPortrait.svg";
export { SvgOrientationPortrait as ReactComponent };